import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { HomeComponent } from './index';

export const HomeRoutes: Routes = [
    {
        path: 'home',
        component: HomeComponent
    }
];

export const HomeRouting: ModuleWithProviders<RouterModule> = RouterModule.forChild(HomeRoutes);
